import React from 'react';
import tw from 'twin.macro';
import { TextLine } from '../text';
import { Icon } from '../icon';
import { LoaderIcon } from 'icons';

export const ButtonSelector = ({ label, type = 'button', isSelected, ...restProps }) => (
  <button
    type={type}
    css={[
      tw`mr-4 last-of-type:mr-0 px-3 py-2 border-b-2 border-icons cursor-pointer transition-all opacity-60`,
      isSelected && tw`border-brand opacity-100`,
    ]}
    {...restProps}
  >
    {label !== '' && (
      <TextLine black text={label} css={[tw`text-icons`, isSelected && tw`text-default`]} />
    )}
  </button>
);

export const Button = ({
  primary,
  secondary,
  ghost,
  warning,
  info,
  danger,
  label = '',
  labelRight = false,
  iconProps = {
    Type: undefined,
  },
  type = 'button',
  animated,
  noHover,
  noSpacing,
  hideLabel,
  loading,
  ...restProps
}) => {
  const { Type } = iconProps;
  return (
    <button
      type={type}
      css={[
        tw`h-9 border-2 border-transparent rounded-full flex justify-center items-center w-max gap-1.5 transition-all active:scale-95`,
        (primary || secondary || ghost || info || warning || danger) && tw`px-3`,
        (primary || secondary || ghost || info || warning || danger) &&
          !noHover &&
          tw`transition-all hover:opacity-75 hover:scale-110 active:scale-95`,
        primary && tw`bg-brand`,
        secondary && tw`bg-secondary`,
        info && tw`bg-info`,
        warning && tw`bg-warning`,
        danger && tw`bg-danger`,
        ghost && tw`bg-transparent border-default group-[.text-light]:border-light`,
        restProps.disabled && tw`opacity-25 hover:opacity-25 transition-none hover:scale-100`,
        loading && tw`relative`,
        Type && label === '' && tw`w-9`,
        ((Type && label === '') || noSpacing) && tw`!px-0`,
      ]}
      {...restProps}
    >
      {loading && (
        <Icon
          Type={LoaderIcon}
          size='medium'
          tw='text-white animate-spin absolute m-auto inset-0'
        />
      )}
      {label !== '' && !hideLabel && (
        <TextLine
          black
          text={label}
          css={[
            labelRight && tw`order-2`,
            (primary || info || warning || danger) && tw`!text-dark`,
            secondary && tw`text-light`,
            ghost && tw`text-default`,
            loading && tw`!text-transparent`,
          ]}
        />
      )}
      {Type && <Icon {...iconProps} css={[labelRight && tw`order-1`]} />}
    </button>
  );
};
